export const RUPEE = '₹';
export const DOLLAR = '$';
export const AED = 'AED';
export const SAR = 'SAR';
export const QAR = 'QAR';
